<template>
  <PreAuthPage>
    <div class="sh-card__head">
      <LogoTile :branding="branding" :alt="tenantName" :size="44" />
      <span class="noaccess__badge"><v-icon size="20" color="warning">block</v-icon></span>
      <!-- PAC-1387: somebody with no company at all on an app that does not take
           sign-ups is not "denied" — the app is simply invite-only. Say that. -->
      <!-- Better Auth BANNED: the account itself is blocked, on every app. -->
      <h1 class="sh-card__title">
        {{
          blocked
            ? t("auth.blockedTitle")
            : inviteOnly
              ? t("auth.inviteOnlyTitle")
              : t("auth.noAccessTitle", { name: tenantName })
        }}
      </h1>
      <p class="sh-card__subtitle">
        {{
          blocked
            ? t("auth.blockedBody")
            : inviteOnly
              ? t("auth.inviteOnlyBody", { name: tenantName })
              : t("auth.noAccessBody")
        }}
      </p>
      <!-- The one fact that resolves most "no access" tickets on the spot:
           which account this is. Two-account users land here constantly. -->
      <p v-if="email" class="sh-whoami">{{ t("common.signedInAs") }} <b>{{ email }}</b></p>
    </div>

    <!-- Sign-out clears the Auth0 session too, so the next "Sign in" asks
         for credentials — that is what "different account" means here. -->
    <v-btn class="noaccess__switch" color="primary" variant="flat" block @click="session.signOut()"
      >{{ t("auth.differentAccountSignIn") }}</v-btn>
    <v-btn
      v-if="support"
      class="noaccess__support"
      :href="support"
      :target="support.startsWith('mailto:') ? undefined : '_blank'"
      rel="noopener noreferrer"
      variant="text"
      size="small"
      block
      >{{ t("auth.contactSupport") }}</v-btn>
  </PreAuthPage>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useSessionStore } from "@/stores/session";
import { supportHref } from "@/tenant/loginLinks";
import LogoTile from "@/shell/LogoTile.vue";
import PreAuthPage from "@/shell/PreAuthPage.vue";

export default defineComponent({
  name: "NoAccess",
  components: { LogoTile, PreAuthPage },
  setup() {
    const { t } = useI18n();
    const session = useSessionStore();
    const tenantName = computed(() => session.tenant?.name || "Metaship");
    const branding = computed(() => session.tenant?.branding ?? null);
    const email = computed(() => session.user?.email || null);
    const support = computed(() => supportHref(session.tenant?.loginPage));
    const blocked = computed(() => session.accountBlocked);
    const inviteOnly = computed(() => session.hasAnyOrganisation === false && session.tenant?.selfServeSignup !== true);
    return { t, session, tenantName, branding, email, support, inviteOnly, blocked };
  },
});
</script>

<style scoped>
.noaccess__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(var(--v-theme-warning), 0.14);
}
.noaccess__switch {
  font-weight: 600;
}
.noaccess__support {
  margin-top: 8px;
  font-size: 12px;
  color: var(--sh-text-60);
}
</style>
